import React from 'react';
import { Link } from 'react-router-dom';
import { useHelp } from '../context/HelpContext';
import styles from '../styles/publicLanding.module.css';

interface CardProps {
  title: string;
  subtitle: string;
  button: string;
  href?: string;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({ title, subtitle, button, href, onClick }) => (
  <div className={styles.card}>
    <h3>{title}</h3>
    <p>{subtitle}</p>
    {href ? (
      <Link to={href} className={styles.cardButton}>
        {button}
      </Link>
    ) : (
      <button onClick={onClick} className={styles.cardButton}>
        {button}
      </button>
    )}
  </div>
);

interface PublicLandingProps {
  onOpenAbout: () => void;
  onLogin: () => void;
  onCreateAccount?: () => void;
}

export default function PublicLanding({ onOpenAbout, onLogin, onCreateAccount }: PublicLandingProps) {
  const { openHelp } = useHelp();

  const handleCreateAccountClick = () => {
    // Open the login modal in signup mode
    if (onCreateAccount) {
      onCreateAccount();
    } else {
      onLogin();
    }
  };

  const handleQuickTour = () => {
    openHelp(undefined, 'tour');
  };

  return (
    <div className={styles.container}>
      <div className={styles.welcomeSection}>
        <p className={styles.welcomeMessage}>Your journey to recovery starts here.</p>
        <button onClick={handleQuickTour} className={styles.quickTourButton}>
          Quick Tour
        </button>
      </div>
      
      <div className={styles.cards}>
        <Card
          title="Assess"
          subtitle="Am I an addict?"
          button="Take Self-Assessment"
          href="/self-assess"
        />
        <Card
          title="Discover"
          subtitle="Learn about addictions and recovery programs"
          button="Explore Programs"
          href="/discover"
        />
        <div className={styles.myJourneyCard}>
          <h3>My Journey</h3>
          <p>Track your personal recovery journey privately and securely</p>
          <div className={styles.buttonGroup}>
            <button onClick={onLogin} className={styles.loginButton}>
              Login
            </button>
            <button onClick={handleCreateAccountClick} className={styles.createAccountButton}>
              Create Account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
